module.exports = __webpack_public_path__ + "static/media/Ontheway.3ec6fdb9.png";